import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * EnforcementModal - Modal shown when time tracking check-in is required
 *
 * Props:
 * - isOpen: Boolean - whether modal is visible
 * - onClose: Function - called when modal is closed/cancelled
 * - onCheckIn: Function - called when user clicks "Check In Now"
 * - locationName: String - shop name for display
 * - loading: Boolean - whether check-in is in progress
 */
const EnforcementModal = ({
  isOpen,
  onClose,
  onCheckIn,
  locationName,
  loading = false
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={!loading}
    >
      <Modal.Header closeButton={!loading}>
        <Modal.Title>
          <i className="fa fa-clock-o text-warning mr-2"></i>
          Check-In Required
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-center py-3">
          <div className="mb-4">
            <i className="fa fa-sign-in fa-3x text-muted"></i>
          </div>

          <p className="mb-3">
            You must check in at <strong>{locationName || 'the shop'}</strong> before starting work on this service.
          </p>

          <p className="text-muted small mb-0">
            Time tracking helps ensure accurate records and timely service delivery.
          </p>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex justify-content-between">
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          variant="primary"
          onClick={onCheckIn}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm mr-2" role="status"></span>
              Checking In...
            </>
          ) : (
            <>
              <i className="fa fa-sign-in mr-2"></i>
              Check In Now
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EnforcementModal;
